import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, {useContext, useEffect} from 'react';
import { withRouter } from 'react-router-dom';
import metadata from './AgentConfirmationPage.metadata.json5';
import styles from './AgentConfirmationPage.module.scss';
import { useTranslator } from '@jutro/locale';
import { truncate } from 'lodash';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import TaxInformationPage from '../TaxInformationPage/TaxInformationPage';
import AgencyInformationPage from '../AgencyInformationPage/AgencyInformationPage';
import CommissionsDirectDepositPage from '../CommissionsDirectDepositPage/CommissionsDirectDepositPage';
import EFTPaymentInfo from '../EFTPaymentInfo/EFTPaymentInfo'
import { BreakpointTrackerContext } from '@jutro/layout';
import UWCompanyUtil from '../../utils/UWCompanyUtil_TWIA.js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { AgentRegistrationService } from '../../../../capabilities/ent-capability-agentregistration/index.js';
import AgentRegistrationWizardTemplate from '../../templates/AgentRegistrationWizardTemplate.jsx';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import messages from './AgentConfirmationPage.messages.js'

function AgentConfirmationPage(props) {
    const { wizardData: registrationVM, updateWizardData, id } = props;
    const breakpoint = useContext(BreakpointTrackerContext)
    const { onValidate, isComponentValid } = useValidation(id);
    const isTWIA = UWCompanyUtil.isTWIACompany(_.get(registrationVM, 'uwcompany'))
    const { showAlert } = useModal();

    // DE15254
    function Text() {
          return  (<div>{'To edit your registration request, either click “Previous” to navigate to the information you wish to edit, or select a section you wish to edit in the navigation menu to the left.'}&nbsp;
         {'After editing your registration information, click the “Next” button to save your edits and navigate back to this page.'} <strong>{'Remember that if you leave the session and do not submit your registration request, the information will not be saved.'}</strong>
         </div>)
    } 

    const overrides = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            readOnly : true
        },
        regInformation: {
                content: Text()
            },
        taxInfoDetails:{
            isConfirmationPage : true,
            wizardData: registrationVM,
            updateWizardData
        },
        agencyInfoDetails: {
            isConfirmationPage : true,
            wizardData: registrationVM,
            updateWizardData

        },
        commisiondepositDetails: {
            isConfirmationPage : true,
            wizardData: registrationVM,
            updateWizardData
        },
        eftPaymentInfoDetails: {
            isConfirmationPage : true,
            visible : isTWIA,
            wizardData: registrationVM,
            updateWizardData

        },
        taxInstructions: {
            visible: isTWIA
        },
        taxtfpaInstructions: {
            visible: !isTWIA 
        },
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            AgencyInformationPage : AgencyInformationPage,
            TaxInformationPage : TaxInformationPage,
            CommissionsDirectDepositPage : CommissionsDirectDepositPage,
            EFTPaymentInfo : EFTPaymentInfo
        },
    };

    const onNext = () => {
        if (!isComponentValid) {
            return false
        }

        const recordID = _.clone(registrationVM.tdiaddressLookup.value)
        const addresses = _.clone(registrationVM.agencyAddresses.value)
        registrationVM.primaryAddress.value = _.find(addresses,(address)=>
            address.recordID = recordID
        )
        if(registrationVM.hasMailingAddress.value === false){
            registrationVM.mailingAddress.value =  registrationVM.primaryAddress.value
        }
        if(!isTWIA){
         registrationVM.agentEFTDTO_TWIA = null;
        }
       //US26499- error messages added
        return AgentRegistrationService.submitNewAgent(
            registrationVM.value
        ).then(response => {
            return registrationVM

        }).catch(() => {
            showAlert({
                title: messages.errors,
                message: messages.agencyFailed,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok,
            }).catch(_.noop);
            return false
        })
    }

    return (
        <WizardPage
            id={id}
            showPrevious={true}
            onNext={onNext}
            template={AgentRegistrationWizardTemplate}

        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={registrationVM}
                onModelChange={updateWizardData}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

export default withRouter(AgentConfirmationPage);
